import React from "react"
import PropTypes from "prop-types"
import {MyContainer} from "./container";
import {makeStyles, Typography} from "@material-ui/core";
import Header from "./header"
import SEO from "./seo";
import {Theme} from "./Theme";
import { Footer } from "./footer"

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(2),
    },
    title: {
        marginBottom: theme.spacing(2),
    }
}));

export const Layout = ({children, showTitle, title, noContainer}) => {
    const classes = useStyles();

    const titleComp = showTitle ? <Typography variant={'h2'} className={classes.title}>{title}</Typography> : null;

    return (
        <Theme>
            <SEO title={title}/>
            <Header/>
            {
                noContainer ? <div className={classes.container}>
                    {titleComp}
                    {children}
                </div> : <MyContainer className={classes.container}>
                    {titleComp}
                    {children}
                </MyContainer>
            }
            <Footer/>
        </Theme>
    )
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
    noContainer: PropTypes.bool,
    title: PropTypes.string.isRequired,
    showTitle: PropTypes.bool,
};

Layout.defaultProps = {
    noContainer: false,
    showTitle: false,
};